import api from '@/libs/axios'

export default {
  async create(payload) {
    const response = await api.post('/admin/items', payload)
    return response.data.data.new_document || null
  },
  async update(payload) {
    let response = await api.put('/admin/items', payload)
    return response
  },
  async delete(payload) {
    const response = await api.delete('/admin/items', {
      data: payload,
    })
    return response
  },
  async getList(params) {
    let response = await api.get('/admin/items', {
      params,
    })
    return response
  },
  async get(params) {
    let response = await api.get('/admin/items/detail', {
      params,
    })
    return response.data.data.document || null
  },
}